// src/css/homeStyle.js

const styles = {
  buttonStyles: {
    // minWidth: "200px",
    width: '230px',
    backgroundColor: "#ffff",
    color: "#0D8B5A",
    padding: "4px 18px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    borderRadius: '14px',
    border: '2px solid #0D8B5A',
    boxShadow: '0px 4px 4px 0px #00000040',
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  boxStyles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typographyStylesGetItOn: {
    fontSize: "14px",
    fontWeight: 500,
  },
  typographyStylesGooglePlay: {
    fontSize: "22px",
    fontWeight: 500,
    marginLeft: "0px",
  },
}

export default styles;
